import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../redux/actions/index';
import update from 'immutability-helper';
import * as enums from '../../utils/enums';
import serviceUtils from '../../utils/service-utils';
import InventoryUtils from '../../utils/inventory-utils';
import getInventoryTableColumns from './setup-table-settings';
import toastr from 'toastr';
import moment from 'moment-timezone';
import _isEqual from 'lodash/isEqual';
import _indexOf from 'lodash/indexOf';
import _isEmpty from 'lodash/isEmpty';
import Inventory from '../models/inventory';
import InventorySetup from './setup';

class InventorySetupContainer extends Component {
    constructor(props) {
        super(props);
        moment.tz.add(
            'Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6'
        );
        this.state = this.initialState();

        this.onSaveRecord = this.onSaveRecord.bind(this);
        this.onHotelChange = this.onHotelChange.bind(this);
        this.onRoomCategoryChange = this.onRoomCategoryChange.bind(this);
        this.onDiscardRecord = this.onDiscardRecord.bind(this);
        this.calendarViewClick = this.calendarViewClick.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.onDaysChange = this.onDaysChange.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
        this.onBooking = this.onBooking.bind(this);
    }

    initialState() {
        return {
            roomType: null,
            selectedRoomCategory: null,
            roomCategoryOptions: [],
            isUpdatingInventory: false,
            date: {
                from: moment.tz(),
                to: moment.tz()
            },
            defaultRTvalues: {
                allotment: {
                    Single: !this.props.isNotTravcoUser ? 10 : 0,
                    Double: !this.props.isNotTravcoUser ? 10 : 0,
                    Twin: !this.props.isNotTravcoUser ? 10 : 0,
                    Triple: 0,
                    Quad: 0,
                    Family: 0,
                    Dormitory: 0,
                    'Double for Single Use': 0,
                    'Twin for Single Use': 0
                },
                freesale: {
                    Single: 10,
                    Double: 10,
                    Twin: 10,
                    Triple: 0,
                    Quad: 0,
                    Family: 0,
                    Dormitory: 0,
                    'Double for Single Use': 0,
                    'Twin for Single Use': 0
                }
            },
            days: '',
            allocation: {
                count: 0,
                releaseDays: 0,
                status: 3
            },
            freesale: {
                count: 0,
                releaseDays: 0,
                status: 3
            },
            allocationRooms: [],
            freesaleRooms: [],
            inventory: {},
            overridingDate: false
        };
    }

    componentDidMount() {
        const { match, actions, model } = this.props;
        if (match && match.params.id) {
            actions.loadRequest(match.params.id, this.state.defaultRTvalues).then((data) => {
                this.setState({ isUpdatingInventory: true });
                this.setHeaderInfo(data.inventory.hotel, data.inventory.roomCategoryName, data.inventory.selectedRoomCategory);
            });
        } else if (!_isEmpty(model.inventory.hotel)) {
            this.setRoomCategoryAndOptions(model);
        } else {
            actions.setModelObject(new Inventory());
        }
    }

    componentWillUnmount() {
        let cleanProps = new Inventory();
        cleanProps.inventory.hotel = this.props.model.inventory.hotel;
        this.props.actions.setModelObject(cleanProps);
    }

    resetState() {
        const { allocationRooms, freesaleRooms } = this.props.model;
        let allocationData = allocationRooms.map((room) => {
            return {
                ...room,
                allotment:
                    !this.props.isNotTravcoUser &&
                    (room.name == 'Single' || room.name == 'Double' || room.name == 'Twin')
                        ? 10
                        : 0,
                availableAllotment:
                    !this.props.isNotTravcoUser &&
                    (room.name == 'Single' || room.name == 'Double' || room.name == 'Twin')
                        ? 10
                        : 0
            };
        });

        let freesaleData = freesaleRooms.map((room) => {
            return {
                ...room,
                allotment: room.name == 'Single' || room.name == 'Double' || room.name == 'Twin' ? 10 : 0,
                availableAllotment: room.name == 'Single' || room.name == 'Double' || room.name == 'Twin' ? 10 : 0
            };
        });

        let state = {
            ...this.props.model,
            allocationRooms: allocationData,
            freesaleRooms: freesaleData,
            allocation: {
                count: 0,
                releaseDays: 0,
                status: 3
            },
            freesale: {
                count: 0,
                releaseDays: 0,
                status: 3
            }
        };

        this.props.actions.setModelObject(state);
    }

    checkInventoryExists(inventoryObj) {
        let checkObj = {
            hotelId: inventoryObj.inventory.hotel.id,
            roomCategoryId: inventoryObj.inventory.roomCategoryId
        };
        this.props.actions.checkInventoryExists(checkObj).then((d) => {
            if (d.inventoryId) {
                this.props.history.push('/inventory-page/' + d.inventoryId);
            }
        });
    }

    setRoomCategoryAndOptions(data) {
        const { roomCategoryId, roomCategoryName, hotel } = data.inventory;

        let selected = null;
        let roomCategoryOptions = [];

        if (roomCategoryId && roomCategoryName) {
            selected = {
                value: roomCategoryId,
                label: roomCategoryName
            };
        }

        roomCategoryOptions = InventoryUtils.getRoomCategoriesFromHotel(hotel);

        this.setHeaderInfo(hotel, roomCategoryName);
        this.setState({
            selectedRoomCategory: selected,
            roomCategoryOptions
        });
    }

    onEditClick(row, index) {
        let date = moment.tz(row.dateOfAllocation, 'Europe/London');
        const hotelRooms = this.props.model.inventory.hotel.roomCategories.find(
            (r) => r.name === this.props.model.inventory.roomCategoryName
        ).roomTypes;
        let model = Object.assign({}, this.props.model, {
            editIndex: index,
            allocationRooms: InventoryUtils.getRoomTypesSorted(row.roomInventory.roomTypes, hotelRooms),
            freesaleRooms: InventoryUtils.getRoomTypesSorted(row.roomInventory.roomTypesFreesale, hotelRooms),
            allocation: {
                count:
                    row.roomInventory.allotment.count == enums.CLOSED_ALLOCATION_FREESALE
                        ? 'C'
                        : row.roomInventory.allotment.count,
                releaseDays:
                    row.roomInventory.allotment.releaseDays == enums.CLOSED_ALLOCATION_FREESALE
                        ? 'C'
                        : row.roomInventory.allotment.releaseDays,
                status: row.roomInventory.allotment.status
            },
            freesale: {
                count:
                    row.roomInventory.freesale.count == enums.CLOSED_ALLOCATION_FREESALE
                        ? 'C'
                        : row.roomInventory.freesale.count == enums.OPEN_INFINITY
                          ? '∞'
                          : row.roomInventory.freesale.count,
                releaseDays:
                    row.roomInventory.freesale.releaseDays == enums.CLOSED_ALLOCATION_FREESALE
                        ? 'C'
                        : row.roomInventory.freesale.releaseDays,
                status: row.roomInventory.freesale.status
            }
        });

        model.allocationRooms = model.allocationRooms.map(room=> {
                if (room.allotment < 0) 
                    room.allotment = 0; 
                return room;
            }
        );

        model.freesaleRooms = model.freesaleRooms.map(room=> {
                if (room.allotment < 0) 
                    room.allotment = 0; 
                return room;
            }
        );

        this.setState(
            update(this.state, {
                date: { from: { $set: date }, to: { $set: date } },
                days: { $set: date.format('dd') }
            })
        );

        this.props.actions
            .setModelObject(model)
            .then(() =>
                document.getElementById('inventory-data-setup').scrollIntoView({ behavior: 'smooth', block: 'end' })
            );
    }

    onDatesChange(startDate, endDate) {
        const overrideDate = this.state.inventoryData
            ? this.state.inventoryData.allocationByDay.findIndex((elm) => {
                  return moment.tz(elm.dateOfAllocation, 'Europe/London').isBetween(startDate, endDate, 'day', '[]');
              })
            : -2;

        this.setState(
            update(this.state, {
                date: { from: { $set: startDate || null }, to: { $set: endDate || null } },
                days: { $set: '' },
                overridingDate: { $set: overrideDate > -1 }
            })
        );
    }

    onDaysChange(days) {
        let state = Object.assign({}, this.state);
        state.days = days;

        const overrideDate = this.state.inventoryData
            ? this.state.inventoryData.allocationByDay.findIndex((elm) => {
                  return moment
                      .tz(elm.dateOfAllocation, 'Europe/London')
                      .isBetween(state.date.from, state.date.to, 'day', '[]');
              })
            : -2;

        this.setState(state);

        if (overrideDate > -1 && !!days) toastr.warning('Data may be overriden on current Dates selected.');
    }

    onHotelChange(selectedHotel) {
        var readOnly = false;
        toastr.remove();

        if (!this.props.model.searchEdit && this.props.model.inventory.inventoryData.allocationByDay.length > 0) {
            toastr.warning('Changing hotels will remove the current data.');
            return;
        }

        if (
            selectedHotel &&
            selectedHotel.roomCategories &&
            (selectedHotel.roomCategories.length === 0 || selectedHotel.roomCategories[0].roomTypes.length === 0)
        ) {
            toastr.warning('No room types available. Please select another hotel.');
            readOnly = true;
        }

        let inventory = Object.assign({}, this.props.model, {
            inventory: this.props.model.inventory,
            readOnly: readOnly
        });

        if (!this.state.isUpdatingInventory) {
            let clearedObject = new Inventory();

            inventory.inventory = Object.assign(clearedObject.inventory, {
                hotel: selectedHotel
            });
        }

        const roomCategoryOptions = InventoryUtils.getRoomCategoriesFromHotel(selectedHotel);
        this.setState({ roomCategoryOptions });

        const { actions } = this.props;

        actions.setGlobalHotel(selectedHotel);
        actions.setModelObject(inventory);
        this.setHeaderInfo(selectedHotel, null);
    }

    onRoomCategoryChange(selected) {
        if (selected.value === '') return;

        const { actions, model } = this.props;

        let allocationRoomsOptions = InventoryUtils.getRoomTypesFromHotel(
            this.props.model.inventory.hotel,
            selected,
            this.state.defaultRTvalues
        );
        let freesaleRoomsOptions = Array.from(allocationRoomsOptions, (obj) => {
            return { ...obj, allotment: obj.allotment == 0 ? this.state.defaultRTvalues.freesale[obj.name] : 0 };
        });

        this.setState(
            update(this.state, {
                selectedRoomCategory: { $set: selected },
                allocationRooms: { $set: allocationRoomsOptions },
                freesaleRooms: { $set: freesaleRoomsOptions }
            })
        );

        let inventoryObj = {
            ...model,
            inventory: {
                ...model.inventory,
                roomCategoryId: selected.value,
                roomCategoryName: selected.label
            },
            allocationRooms: allocationRoomsOptions,
            freesaleRooms: freesaleRoomsOptions
        };

        if (!this.state.isUpdatingInventory) this.checkInventoryExists(inventoryObj);

        actions.setModelObject(inventoryObj);

        actions.setGlobalRoomCategory(selected.value);

        this.setHeaderInfo(model.inventory.hotel, selected.label);
    }

    setHeaderInfo(hotel, roomCategory) {
        const { actions, headerInfo } = this.props;
        const newData = [
            {
                name: 'Country',
                data: hotel ? hotel.country.name : null
            },
            {
                name: 'Region',
                data: hotel && hotel.city.primaryCountryRegion ? hotel.city.primaryCountryRegion.name : null
            },
            {
                name: 'City',
                data: hotel ? hotel.city.name : null
            },
            {
                name: 'Hotel',
                data: hotel ? `${hotel.name} ( ${hotel.code} )` : null
            },
            {
                name: 'Currency',
                data: hotel && hotel.currency ? hotel.currency.isoCode : null
            },
            { name: 'Room category', data: roomCategory }
        ];

        const newHeaderInfo = serviceUtils.processHeaderInfo(newData, headerInfo);
        actions.setHeaderInfo(newHeaderInfo);
    }

    addInventory(status) {
        let dailyAllotments = this.refactorToModel(status);

        let modelObject = {
            ...this.props.model,
            inventory: {
                ...this.props.model.inventory,
                inventoryData: {
                    allocationByDay: dailyAllotments
                }
            },
            editIndex: -1,
            allocationActive: !this.props.isNotTravcoUser,
            freesaleActive: true
        };

        this.props.actions.setModelObject(modelObject).then(() => {
            this.resetState();
            document.getElementById('inventory-data-table').scrollIntoView({ behavior: 'smooth' });
        });
    }

    refactorToModel(status) {
        const { model, isNotTravcoUser } = this.props;
        let dailyAllotments = [];

        let days = this.state.days.split(',');

        let allocationRooms = [ ...model.allocationRooms ];
        let freesaleRooms = [ ...model.freesaleRooms ];

        // Allows new records to be added with either of the 2 sections to be disabled. The disabled secion will be set to 0
        if (model.allocationActive === false) {
            allocationRooms.forEach((el, index) => {
                allocationRooms[index].allotment = 0;
                allocationRooms[index].availableAllotment = 0;
            });
        }
        if (model.freesaleActive === false) {
            freesaleRooms.forEach((el, index) => {
                freesaleRooms[index].allotment = 0;
                freesaleRooms[index].availableAllotment = 0;
            });
        }

        for (
            let iterationDate = moment.tz(this.state.date.from, 'Europe/London');
            iterationDate.isSameOrBefore(this.state.date.to, 'day');
            iterationDate.add(1, 'days')
        ) {
            if (_indexOf(days, iterationDate.format('dd')) > -1) {
                let { allotmentCount, freeSaleCount } = this.checkClosedAllocationFreesaleCount(iterationDate);
                let bookedAllocation = allotmentCount;
                let bookedFreesale = freeSaleCount;
                let dateExists = false;

                if (isNotTravcoUser) {
                    let savedDataIndex = model.inventory.inventoryData.allocationByDay.findIndex((el) =>
                        moment.tz(el.dateOfAllocation, 'Europe/London').isSame(iterationDate, 'day')
                    );

                    if (savedDataIndex === -1) {
                        allocationRooms.forEach((el, index) => {
                            allocationRooms[index].allotment = 0;
                            allocationRooms[index].availableAllotment = 0;
                        });
                    } else {
                        allocationRooms =
                            model.inventory.inventoryData.allocationByDay[savedDataIndex].roomInventory.roomTypes;
                    }
                }

                ({ dateExists, bookedAllocation, bookedFreesale } = this.checkIfAnyAllotmentUsed(
                    iterationDate,
                    dateExists,
                    bookedAllocation,
                    bookedFreesale
                ));

                let matchingExistingInventory = model.inventory.inventoryData.allocationByDay.find((t) =>
                    moment.tz(t.dateOfAllocation, 'Europe/London').isSame(iterationDate, 'days')
                );

                let allocReleaseDays = model.allocation.releaseDays;
                let freesaleReleaseDays = model.freesale.releaseDays;
                let isAllocFreesaleExists = typeof matchingExistingInventory !== 'undefined';

                if (isAllocFreesaleExists) {
                    if (model.allocationActive == false) {
                        allocationRooms = matchingExistingInventory.roomInventory.roomTypes;
                        allocReleaseDays = matchingExistingInventory.roomInventory.allotment.releaseDays;
                    }
                    if (model.freesaleActive == false) {
                        freesaleRooms = matchingExistingInventory.roomInventory.roomTypesFreesale;
                        freesaleReleaseDays = matchingExistingInventory.roomInventory.freesale.releaseDays;
                    }
                }

                if (model.allocationActive === false) {
                    allotmentCount =
                        !isAllocFreesaleExists
                            ? 0
                            : matchingExistingInventory.roomInventory.allotment.count;
                }
                if (model.freesaleActive === false) {
                    freeSaleCount =
                        !isAllocFreesaleExists
                            ? 0
                            : matchingExistingInventory.roomInventory.freesale.count;
                }

                let allocationByDay = {
                    dateOfAllocation: moment.tz(iterationDate.format('DD/MMM/YYYY'), 'Europe/London').toISOString(),
                    status: status,
                    roomInventory: {
                        roomTypes: !model.allocationActive
                            ? allocationRooms
                            : this.recalculateRoomTypeAllotments(iterationDate, allocationRooms, 'roomTypes'),
                        roomTypesFreesale: !model.freesaleActive 
                            ? freesaleRooms 
                            : this.recalculateRoomTypeAllotments(iterationDate, freesaleRooms, 'roomTypesFreesale'),
                        allotment: {
                            count:
                                model.searchEdit == true &&
                                this.state.isUpdatingInventory == false &&
                                isAllocFreesaleExists === false
                                    ? 0
                                    : allotmentCount,
                            releaseDays:
                                model.allocation.releaseDays === 'C'
                                    ? enums.CLOSED_ALLOCATION_FREESALE
                                    : allocReleaseDays,
                            status: model.allocation.status
                        },
                        freesale: {
                            count:
                                model.searchEdit == true &&
                                this.state.isUpdatingInventory == false &&
                                isAllocFreesaleExists === false
                                    ? 0
                                    : freeSaleCount,
                            releaseDays:
                                model.freesale.releaseDays === 'C'
                                    ? enums.CLOSED_ALLOCATION_FREESALE
                                    : freesaleReleaseDays,
                            status: model.freesale.status
                        },
                        bookedDetails: this.getBookingDetails(
                            dateExists,
                            matchingExistingInventory,
                            allotmentCount,
                            freeSaleCount,
                            model.allocation.count,
                            model.freesale.count
                        )
                    }
                };

                // if it's a hotel user, just splat the existing allotment straight over the top
                if (this.props.isNotTravcoUser) {
                    if (typeof allocationByDay.allotment !== 'undefined')
                        allocationByDay.allotment = matchingExistingInventory.allotment;
                    if (matchingExistingInventory)
                        allocationByDay.roomInventory.allotment = matchingExistingInventory.roomInventory.allotment;
                    else
                        allocationByDay.roomInventory.allotment = {
                            count: 0,
                            releaseDays: 0,
                            status: 3
                        };
                }

                dailyAllotments.push(allocationByDay);
            }
        }
        if (model.inventory.inventoryData.allocationByDay.length > 0)
            dailyAllotments = InventoryUtils.mergeObjects(
                model.inventory.inventoryData.allocationByDay,
                dailyAllotments
            );

        // Resort by date
        dailyAllotments.sort((a, b) => a.dateOfAllocation.localeCompare(b.dateOfAllocation));

        return dailyAllotments;
    }

    checkClosedAllocationFreesaleCount(iterationDate) {
        const { allocation, freesale, inventory } = this.props.model;
        let allotmentCount;

        if (this.props.isNotTravcoUser) {
            let existingData = inventory.inventoryData.allocationByDay.find((e) =>
                moment.tz(e.dateOfAllocation, 'Europe/London').isSame(iterationDate, 'days')
            );
            if (existingData) allotmentCount = existingData.roomInventory.bookedDetails.currentAllocationTotal;
        } else {
            allotmentCount = allocation.count === 'C' ? enums.CLOSED_ALLOCATION_FREESALE : allocation.count;
        }

        let freeSaleCount =
            freesale.count === 'C'
                ? enums.CLOSED_ALLOCATION_FREESALE
                : freesale.count == '∞' ? enums.OPEN_INFINITY : freesale.count;

        return { allotmentCount, freeSaleCount };
    }

    getBookingDetails(
        dateExists,
        matchingExistingInventory,
        allocationCount,
        freesaleCount,
        loadedAllocation,
        loadedFreesale
    ) {
        let newAllocationTotal = loadedAllocation === 'C' ? enums.CLOSED_ALLOCATION_FREESALE : loadedAllocation;
        let newFreesaleTotal = loadedFreesale === 'C'
                ? enums.CLOSED_ALLOCATION_FREESALE
                : loadedFreesale === '∞' ? enums.OPEN_INFINITY : loadedFreesale;

        if (dateExists){
            newAllocationTotal = matchingExistingInventory.roomInventory.allotment.count !== loadedAllocation && loadedAllocation != 0
                ? allocationCount - matchingExistingInventory.roomInventory.bookedDetails.allocationUsed
                : loadedAllocation === 'C' ? enums.CLOSED_ALLOCATION_FREESALE : matchingExistingInventory.roomInventory.bookedDetails.currentAllocationTotal;

            newFreesaleTotal = matchingExistingInventory.roomInventory.freesale.count !== loadedFreesale
                ? freesaleCount - matchingExistingInventory.roomInventory.bookedDetails.freesaleUsed
                : loadedFreesale === 'C'
                ? enums.CLOSED_ALLOCATION_FREESALE
                : loadedFreesale === '∞' ? enums.OPEN_INFINITY : matchingExistingInventory.roomInventory.bookedDetails.currentFreesaleTotal;
        }
        

        let bookingDetails = {
            dateBooked: moment.tz('Europe/London').toISOString(),
            allocationUsed: dateExists ? matchingExistingInventory.roomInventory.bookedDetails.allocationUsed : 0,
            freesaleUsed: dateExists ? matchingExistingInventory.roomInventory.bookedDetails.freesaleUsed : 0,
            currentAllocationTotal: newAllocationTotal,
            currentFreesaleTotal: newFreesaleTotal,
            currentTotal: newAllocationTotal + newFreesaleTotal,
            totalBooked: matchingExistingInventory
                ? matchingExistingInventory.roomInventory.bookedDetails.totalBooked
                : 0
        };

        return bookingDetails;
    }

    recalculateRoomTypeAllotments(iterationDate, roomtypes, property) {
        let iterationDateData = this.props.model.inventory.inventoryData.allocationByDay.find((e) =>
            moment.tz(e.dateOfAllocation, 'Europe/London').isSame(iterationDate, 'days')
        );

        if (typeof iterationDateData !== 'undefined') {
            let recalculatedData = [];
            let isReopening;

            if (property === 'roomTypes') isReopening = this.props.model.allocation.count !== 'C' && iterationDateData.roomInventory.allotment.count === enums.CLOSED_ALLOCATION_FREESALE;
            else isReopening = this.props.model.freesale.count !== 'C' && iterationDateData.roomInventory.freesale.count === enums.CLOSED_ALLOCATION_FREESALE;

            iterationDateData.roomInventory[property].filter((r) => roomtypes.find((a) => a.name === r.name)).forEach((roomData) => {
                let loadedAllotment = roomtypes.find((a) => a.name === roomData.name).allotment;
                
                const diff = roomData.allotment - roomData.availableAllotment;

                let roomType = Object.assign({}, roomData, {
                    allotment: loadedAllotment,
                    availableAllotment: isReopening ? loadedAllotment :
                        loadedAllotment !== roomData.allotment ? loadedAllotment - diff : roomData.availableAllotment
                });

                recalculatedData.push(roomType);
            });
            return recalculatedData;
        }

        return roomtypes;
    }

    checkIfAnyAllotmentUsed(iterationDate, dateExists, bookedAllocation, bookedFreesale) {
        let iterationDateData = this.props.model.inventory.inventoryData
            ? this.props.model.inventory.inventoryData.allocationByDay.find((d) =>
                  moment.tz(d.dateOfAllocation, 'Europe/London').isSame(iterationDate, 'day')
              )
            : null;

        if (iterationDateData) {
            dateExists = true;

            if (this.props.isNotTravcoUser) {
                bookedAllocation = iterationDateData.roomInventory.bookedDetails.allocationUsed;
            } else {
                bookedAllocation =
                    iterationDateData.roomInventory.allotment.count == enums.CLOSED_ALLOCATION_FREESALE
                        ? 0
                        : iterationDateData.roomInventory.bookedDetails.allocationUsed;
            }

            bookedFreesale =
                iterationDateData.roomInventory.freesale.count == enums.CLOSED_ALLOCATION_FREESALE
                    ? 0
                    : iterationDateData.roomInventory.bookedDetails.freesaleUsed;
        }
        return { dateExists, bookedAllocation, bookedFreesale };
    }

    onSaveRecord() {
        const { allocationRooms, freesaleRooms, allocation, freesale } = this.props.model;
        let allotmentMaxCount = 0;

        let inventory = Object.assign({}, this.props.model, {
            to: this.state.date.to,
            from: this.state.date.from
        });

        let isAllocationExpiring = InventoryUtils.checkReleaseDayIsValid(inventory);

        if (!this.props.isNotTravcoUser && isAllocationExpiring == 1) {
            toastr.warning('Allocation is about to expire. Please check Release period.');
        }

        allocationRooms.forEach((element) => {
            allotmentMaxCount += element.allotment;
        });

        if (!this.props.isNotTravcoUser && allotmentMaxCount < allocation.count) {
            toastr.warning('Allocation must be less than the total number of rooms.');
            return;
        }

       
        allotmentMaxCount = 0;
        freesaleRooms.forEach((element) => {
            allotmentMaxCount += element.allotment;
        });

        if (allotmentMaxCount < freesale.count) {
            toastr.warning('Freesale must be less than the total number of rooms.');
            return;
        }
        allotmentMaxCount = 0;
        allocationRooms.forEach((element) => {
            allotmentMaxCount += element.allotment;
        });

        if (allotmentMaxCount > 0 && allocation.count == 0) {
            toastr.warning('Total Allocation is zero.');
          //  return;
        }
        allotmentMaxCount = 0;
        freesaleRooms.forEach((element) => {
            allotmentMaxCount += element.allotment;
        });

        if (allotmentMaxCount > 0 &&   freesale.count == 0 ) {
            toastr.warning('Total Freesale is zero.');
       //     return;
        }


        this.addInventory(isAllocationExpiring);
    }

    onDiscardRecord() {
        let inventory = { ...this.props.model };
        inventory.editIndex = -1;
        this.props.actions.setModelObject(inventory).then(() => {
            this.resetState();
        });
    }

    onBooking(row, context) {
        let url =
            `${this.props.settings.bookingUrl}/search/` +
            context.props.model.inventory.hotel.id +
            '?date=' +
            row.original.dateOfAllocation;

        window.open(url, '_self');
    }

    calendarViewClick() {
        // let data = this.props.validityRates.map(x => { return { from: x.from, to: x.to, days: x.days, summary: '' }; });
        this.props.onCalendarViewClick(
            'Validity',
            'validity',
            this.props.model.inventory.inventoryDataFiltered,
            getInventoryTableColumns,
            this
        );
    }

    render() {
        const { token, model, settings } = this.props;
        return (
            <InventorySetup
                model={model}
                token={token}
                settings={settings}
                {...this.state}
                onSaveRecord={this.onSaveRecord}
                onHotelChange={this.onHotelChange}
                onRoomCategoryChange={this.onRoomCategoryChange}
                onDiscardRecord={this.onDiscardRecord}
                onDatesChange={this.onDatesChange}
                onDaysChange={this.onDaysChange}
                onEditClick={this.onEditClick}
                onBooking={this.onBooking}
            />
        );
    }
}

function mapStateToProps(state) {
    let isNotTravcoUser =
        state.oidc.user && state.oidc.user.profile ? state.oidc.user.profile['travco_user_type'] !== 'Travco' : true;

    let model = {
        ...state.model,
        allocationActive: isNotTravcoUser || state.model.allocationActive,
        editIndex: typeof state.model.editIndex === 'undefined' ? -1 : state.model.editIndex
    };

    return {
        token: state.oidc.user !== null ? state.oidc.user.id_token : '',
        settings: state.settings,
        model,
        isNotTravcoUser,
        headerInfo: state.globalData.headerInfo || []
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InventorySetupContainer);
